import { FC } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { useAuth0 } from '@auth0/auth0-react';
import '../../themes/glass/glass-light/theme-base.scss'; //theme

export const LoginButton: FC = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
      <Card
        className="flex justify-content-start tw-text-center"
        title={
          <div className="tw-flex tw-flex-col tw-items-center tw-gap-2">
            <img src={'/circle.png'} alt="circle" width={50} height={50} />
            <span>
              Welcome to <br />
              <em>Teach to One Roadmaps </em> !
            </span>
          </div>
        }
      >
        <div className="flex flex-column gap-lg align-items-center w-full">
          <Button
            data-testid="login"
            label="Login"
            icon="nc_icon-nc_next icon-md"
            iconPos="right"
            onClick={() => {
              sessionStorage.setItem('track_login_action', 'true');
              loginWithRedirect();
            }}
            className="nc_button-large flex mx-auto tw-w-full !tw-px-36 !tw-rounded-full"
          ></Button>
          <div className="flex w-full justify-content-center">
            <a href="https://teachtoone.org/terms-of-use/" target="_blank" rel="noreferrer">
              Terms & Rules
            </a>
          </div>
        </div>
      </Card>
    </div>
  );
};
